import { createFileRoute } from '@tanstack/react-router'

import { Forgot } from '~/boundedContext/auth/pages/forgot'

export const Route = createFileRoute('/auth/forgot')({
  component: Forgot,
})
